import {MISSING_COMMUNICATION_WARNING_STRINGS} from '../../../../../../Shared/Constants/MissingCommunicationWarning/MissingCommunicationWarning';

export const mapMissingCommunicationWarningEnum = missingCommunicationWarningEnum => {
	return MISSING_COMMUNICATION_WARNING_STRINGS[missingCommunicationWarningEnum];
};
